import { createFileRoute } from "@tanstack/react-router";
import { SITE } from "@/lib/site";
import { seoTitle, seoDescription } from "@/lib/seo-meta";

const TITLE = seoTitle("Termos de Uso — Liderança com Valores");
const DESC = seoDescription(
  "Termos de Uso da Liderança com Valores: regras de utilização do site, dos conteúdos, dos comentários e dos links de parceiros.",
);

export const Route = createFileRoute("/termos-de-uso")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "/termos-de-uso" },
    ],
    links: [{ rel: "canonical", href: `${SITE.baseUrl}/termos-de-uso` }],
  }),
  component: TermosPage,
});

function TermosPage() {
  const updated = "9 de julho de 2026";
  return (
    <article className="container-svg max-w-3xl py-16">
      <header className="mb-10">
        <p className="text-xs uppercase tracking-widest text-primary font-semibold">Documento legal</p>
        <h1 className="mt-2 text-4xl font-semibold">Termos de Uso</h1>
        <p className="mt-3 text-sm text-muted-foreground">Última atualização: {updated}</p>
      </header>

      <div className="prose max-w-none space-y-6 text-[15px] leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-foreground">1. Aceitação</h2>
          <p>Ao acessar e utilizar o site da {SITE.name}, você declara ter lido, compreendido e concordado com estes Termos de Uso.</p>
        </section>
        <section>
          <h2 className="text-foreground">2. Sobre o site</h2>
          <p>A {SITE.name} é uma plataforma editorial independente que publica artigos, análises e guias sobre liderança, gestão e empreendedorismo. Não vendemos produtos diretamente — quando indicamos, direcionamos o leitor para lojas parceiras via links devidamente identificados.</p>
        </section>
        <section>
          <h2 className="text-foreground">3. Links de parceiros</h2>
          <p>Em alguns artigos há links de parceiros comerciais. Ao clicar e comprar, podemos receber uma comissão, sem custo extra para você. A transação é integralmente regida pelos termos da loja vendedora.</p>
        </section>
        <section>
          <h2 className="text-foreground">4. Uso permitido</h2>
          <p>Você concorda em usar o site para fins lícitos, respeitando a legislação, bons costumes e direitos de terceiros. É proibido:</p>
          <ul className="list-disc pl-6">
            <li>Reproduzir artigos ou conteúdos sem autorização;</li>
            <li>Tentar acessar áreas restritas;</li>
            <li>Usar bots ou scrapers não autorizados;</li>
            <li>Publicar conteúdo ofensivo ou que viole direitos autorais.</li>
          </ul>
        </section>
        <section>
          <h2 className="text-foreground">5. Conteúdo</h2>
          <p>Textos, imagens e marcas são protegidos por direitos autorais. Reprodução total ou parcial depende de autorização escrita do time editorial.</p>
        </section>
        <section>
          <h2 className="text-foreground">6. Informações e preços</h2>
          <p>Buscamos manter os artigos atualizados, mas dados, preços e disponibilidade podem variar a qualquer momento. Confirme sempre antes de tomar uma decisão.</p>
        </section>
        <section>
          <h2 className="text-foreground">7. Limitação de responsabilidade</h2>
          <p>Não nos responsabilizamos por problemas decorrentes de compras realizadas em lojas parceiras (entrega, troca, defeito). Reclamações devem ser direcionadas à loja vendedora.</p>
        </section>
        <section>
          <h2 className="text-foreground">8. Alterações</h2>
          <p>Estes Termos podem ser atualizados a qualquer momento. A versão vigente é a publicada nesta página.</p>
        </section>
        <section>
          <h2 className="text-foreground">9. Foro</h2>
          <p>Fica eleito o foro da comarca de São Paulo/SP para dirimir quaisquer questões, com renúncia a qualquer outro, por mais privilegiado que seja.</p>
        </section>
      </div>
    </article>
  );
}
